import { defineRouteDef, z } from '@/domains/common/api';
import type { UserPreferences } from '@/external/db/types';

const preferenceValueSchemas = {
  auto_confirm: z.boolean(),
  show_tool_logs: z.boolean(),
  tour_completed: z.boolean(),
  tour_dismissed_steps: z.array(z.string().max(64)).max(64),
} satisfies { [K in keyof UserPreferences]: z.ZodType<UserPreferences[K]> };

const preferenceKeySchema = z.keyof(z.object(preferenceValueSchemas));

// The client's setter is generic over the key, so the pair cannot be typed as a
// discriminated union without a cast; it is checked at runtime instead.
export const putPreferenceRoute = defineRouteDef({
  method: 'PUT',
  path: '/api/preferences',
  audience: 'user',
  body: z
    .object({ key: preferenceKeySchema, value: z.union(Object.values(preferenceValueSchemas)) })
    .refine(({ key, value }) => preferenceValueSchemas[key].safeParse(value).success, {
      message: 'preference value type does not match key',
    }),
  output: z.object({ ok: z.literal(true) }),
});
